<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<p-table
  #pt
  [value]="msgCampaigns"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="msgCampaignId"
  selectionMode="single"
  [(selection)]="msgCampaign"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [paginator]="showPagination"
  [rows]="25"
  [rowsPerPageOptions]="[25, 100, 200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped"
  [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true"
  [autoLayout]="true"
  [responsive]="true"
  >
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px">MsgCampaigns</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button
            pButton
            pRipple
            class="p-button-text"
          style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          "
            (click)="reloadPage()"
            >
            Clear Filters
          </button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button
            pButton
            pRipple
            class="p-button-outlined"
            style="padding: 0.643rem 0.75rem !important"
            (click)="onOpenFormAdd()"
            >
            New MsgCampaign +
          </button>
        }
        <button
          pButton
          pRipple
          class="p-button"
          style="padding: 0.643rem 0.75rem !important"
          (click)="onOpenFormAdd()"
          >
          New MsgCampaign +
        </button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{ width: col.width }">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{ width: 'auto' }"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgCampaignId', 'in')" class="idFilter"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th><p-dropdown #aa [options]="statuses" appendTo="body" class="st"
          (onChange)="pt.filter($event.value, 'status', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item"><span>{{option.name}}</span></ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderEmail', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderMobileNum', 'in')"></th>
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'subject', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobileText', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th> -->
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'opsNotes', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'statusMsg', 'in')" style="width:100px;"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-msgCampaign>
  <tr [pSelectableRow]="msgCampaign">
    <td>{{ msgCampaign.msgCampaignId }}</td>
    <td>{{ msgCampaign.name }}</td>
    <td>{{ getStatusName( msgCampaign ) }}</td>
    <td>{{ msgCampaign.type }}</td>
    <td>{{ msgCampaign.sendOnDate|date:'medium' }}</td>
    <td>{{ msgCampaign.senderName }}</td>
    <td>{{ msgCampaign.senderEmail }}</td>
    <td>{{ msgCampaign.senderMobileNum }}</td>
    <!-- <td>{{ msgCampaign.subject }}</td>
    <td>{{ msgCampaign.mobileText }}</td>
    <td>{{ msgCampaign.sendByEmail }}</td>
    <td>{{ msgCampaign.sendBySms }}</td> -->
    <td>{{ msgCampaign.opsNotes }}</td>
    <td>{{ msgCampaign.statusMsg }}</td>
    <td>
      <span style="float: none">
        <a>
          <i
            class="pi pi-pencil"
            aria-hidden="true"
            style="color: blue; font-size: 110%; padding-right: 20px"
            (click)="onOpenFormEdit(msgCampaign)"
          ></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
